import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Tarea } from '../../../shared/';
import { FormGroup, FormControl } from '@angular/forms';
import { HeaderDescriptionTaskDataService } from './shared/header-description-task.data.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-header-description-task',
  templateUrl: './header-description-task.component.html',
  styleUrls: ['./header-description-task.component.scss'],
  providers: [HeaderDescriptionTaskDataService]
})
export class HeaderDescriptionTaskComponent implements OnInit, OnDestroy {
  // Datos de la tarea
  @Input() task: Tarea;
  // Define estilos personalizados para el contenedor del componente
  @Input() class: Array<string> | string = '';
  // Tarea finalizada
  @Input() finishTask = false;
  // Formulario de fecha de finalizacion
  formDate: FormGroup = new FormGroup({
    dateInit: new FormControl(),
    dateFinish: new FormControl()
  });
  // Define la fecha maxima de los campos de fechas
  max = new Date();
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Notifica la actualizacion de informacion de la tarea
  @Output() updateTask: EventEmitter<Partial<Tarea>> = new EventEmitter();

  constructor(private hdtds: HeaderDescriptionTaskDataService) { }

  ngOnInit() {
    if (this.task.fecha_activacion) {
      this.formDate.controls['dateInit'].setValue(this.task.fecha_activacion);
    }
    if (this.task.fecha_finalizacion) {
      this.formDate.controls['dateFinish'].setValue(this.task.fecha_finalizacion);
    }
    this.formDate.valueChanges.subscribe(data => {
      this.hdtds.setDateInitAndFinish(this.task.id, data.dateInit, data.dateFinish).subscribe(resp => {
        if (resp) {
          const form = {
            fecha_activacion: data.dateInit,
            fecha_finalizacion: data.dateFinish
          };
          this.updateTask.emit(form);
        }
      }, err => console.error(err));
    });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Limpia el campo dentro del formulario indicado
   *
   * @param {string} nameField
   * @memberof HeaderDescriptionTaskComponent
   */
  emptyField(nameField: string) {
    if (!this.formDate.controls[nameField].disabled) {
      this.formDate.controls[nameField].reset();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/shared/header-description-task/header-description-task.component.ts